import React from 'react';
import { useParams } from 'react-router-dom';
import { Logs } from 'components/common/logs';
import { HasAccess } from 'components/common/accessControl';
import { PERMISSIONS } from 'constants/permissions';

export const ClientLogs = React.memo(() => {
  const { id } = useParams();
  return (
    <HasAccess role={PERMISSIONS.clients.logs.read}>
      <div className={'logs-layout-container'}>
        <Logs id={id} entityName={'CLIENT'} />
      </div>
    </HasAccess>
  );
});
